import * as Constants from './constants'
import * as Types from './types'

const initialState = {
  communityIdentifier: '',
  content: {},
  emailTemplate: '',
  isFetchingPreview: false,
  isModalOpen: false,
  isShowingPreview: false,
  previewHtml: '',
}
export const reducer = (state: Types.State = initialState, action: any) => {
  switch (action.type) {
    case Constants.TOGGLE_PREVIEW_NEWSBRIEF:
      return {
        ...state,
        communityIdentifier: action.communityIdentifier,
        content: action.contentPayload,
        emailTemplate: action.templateName,
        isModalOpen: !state.isModalOpen,
      }
    case Constants.FETCH_PREVIEW_REQUEST:
      return {
        ...state,
        isFetchingPreview: true,
        isShowingPreview: false,
      }
    case Constants.FETCH_PREVIEW_SUCCESS:
      return {
        ...state,
        isFetchingPreview: false,
        isShowingPreview: true,
        previewHtml: action.payload.response.html,
      }
    case Constants.FETCH_PREVIEW_ERROR:
      return {
        ...state,
        isFetchingPreview: false,
      }
    default:
     return state
  }
}



// WEBPACK FOOTER //
// ./src/pages/newsbrief/preview-newsbrief/reducer.ts